enum GalleryType {
  FullScreen = 'fullScreen',
  Tile = 'tile'
}

export default GalleryType;
